import React from "react";

import LockIcon from "@uui/Lock03";

import { Tab as MuiTab, TabProps as MuiTabProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import { Row, StackProps } from "@rui/Stack";
import TooltipWrapper from "@rui/TooltipWrapper";

export interface TabProps extends MuiTabProps {
  count: number;
  countStartIcon?: React.ReactNode;
  locked?: boolean;
  tooltip?: {
    title: string;
    show: boolean;
  };
}

const StyledTab = styled(MuiTab)(({ theme }) => ({
  minHeight: "26px",
  height: "26px",
  fontSize: "1rem",
  lineHeight: "20px",
  letterSpacing: "-0.02rem",
  fontWeight: 500,
  color: theme.palette.shades.neutral[500],
  borderRadius: "6px",
  padding: "4px 8px",

  "&:hover": {
    color: theme.palette.shades.neutral[700],
  },

  "&.Mui-selected": {
    background: "none !important",
    color: theme.palette.shades.primary[600],

    ".sidebar-tab__count": {
      backgroundColor: theme.palette.shades.primary[50],
      color: theme.palette.shades.primary[500],
    },
  },

  "&.Mui-disabled": {
    fontWeight: 400,
    color: theme.palette.shades.neutral[300],
  },
}));

const Count = styled((props: StackProps) => (
  <Row variant="center" {...props} />
))(({ theme }) => ({
  borderRadius: "4px",
  backgroundColor: theme.palette.shades.neutral[50],
  padding: "2px 4px",
  fontSize: "0.75rem",
  fontWeight: 500,
  color: theme.palette.shades.neutral[400],
  lineHeight: 14 / 12,
  minHeight: "18px",
  minWidth: "22px",
  "& svg": {
    fontSize: "12px",
  },
}));

const SidebarTab = ({
  count,
  countStartIcon = null,
  label,
  locked,
  tooltip,
  ...props
}: TabProps) => (
  <StyledTab
    disableRipple
    {...props}
    label={
      <Row variant="center" spacing={1}>
        <span>{label}</span>
        {(count > 0 || locked) && (
          <TooltipWrapper {...tooltip}>
            <Count className="sidebar-tab__count" spacing={0.5}>
              {countStartIcon}
              {locked ? <LockIcon /> : count}
            </Count>
          </TooltipWrapper>
        )}
      </Row>
    }
  />
);

export default SidebarTab;
